import { useEffect, useRef, useState } from 'react';
import { useAuth } from './AuthContext';

export function localToday() {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export default function MovieJournal({ movie }) {
  const { user, experience, saveExperienceItem, openAuth } = useAuth();
  const entry = experience.journal?.[`movie_${movie.id}`];
  const [rating, setRating] = useState('');
  const [notes, setNotes] = useState('');
  const [watchedDate, setWatchedDate] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const dirty = useRef(false);
  useEffect(() => {
    if (dirty.current) return;
    setRating(entry?.rating || ''); setNotes(entry?.notes || ''); setWatchedDate(entry?.watchedDate || '');
  }, [entry]);
  const change = setter => event => { dirty.current = true; setter(event.target.value); setMessage(''); };
  const save = async event => {
    event.preventDefault();
    if (!user) { openAuth(); return; }
    setBusy(true); setMessage('');
    try {
      const saved = await saveExperienceItem('journal', `movie_${movie.id}`, { id: movie.id, title: movie.title, posterPath: movie.poster_path || null, genreIds: movie.genres?.map(genre => genre.id) || movie.genre_ids || [], genreNames: movie.genres?.map(genre => genre.name) || [], runtime: movie.runtime || 0, rating: Number(rating) || 0, notes: notes.trim(), watchedDate });
      if (saved) { dirty.current = false; setMessage('Saved to your private journal.'); }
    } catch { setMessage('Could not save your entry. Your draft is still here. Try again.'); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    setBusy(true);
    try { if (await saveExperienceItem('journal', `movie_${movie.id}`, null)) { dirty.current = false; setRating(''); setNotes(''); setWatchedDate(''); setMessage('Journal entry removed.'); } }
    catch { setMessage('Could not remove the entry. Try again.'); }
    finally { setBusy(false); }
  };
  return <section className="personal-feature journal-panel" id="movie-journal"><header><span className="section-kicker">JUST FOR YOU</span><h2>Your movie journal</h2><p>Keep your rating, memories, and watched date private.</p></header><form onSubmit={save}>
    <div className="journal-fields"><label>Your rating<select value={rating} onChange={change(setRating)}><option value="">Not rated</option>{[1,2,3,4,5].map(value => <option key={value} value={value}>{value} / 5 stars</option>)}</select></label><label>Watched on<input type="date" value={watchedDate} max={localToday()} onChange={change(setWatchedDate)} /></label></div>
    <label>Private notes<textarea value={notes} maxLength={3000} rows={4} onChange={change(setNotes)} placeholder="What stayed with you after the credits?" /></label><small>{notes.length} / 3000 characters · Only visible in your account</small>
    <div className="feature-actions"><button disabled={busy} type="submit">{busy ? 'Saving…' : user ? 'Save journal entry' : 'Sign in to save'}</button>{entry && <button disabled={busy} type="button" className="secondary-action" onClick={remove}>Delete entry</button>}</div><p className="feature-status" role="status">{message}</p>
  </form></section>;
}
